module.exports = __webpack_public_path__ + "static/media/cosa-offriamo.02c5b721.jpg";